import React from 'react';
import { BaseEdge, getBezierPath, EdgeProps } from 'reactflow';

/**
 * Bezier edge that shifts BOTH endpoints by a vertical `data.offset` (px) before drawing.
 *
 * Two aggregated edges between the same (neighbor, route-table) handles — e.g. the pink SHARED
 * edge and the blue UNIQUE edge (CTX-98) — share identical anchor points, so a plain bezier draws
 * them on top of each other (only the curvature differs, and that converges back to the same
 * points at both ends). Offsetting the endpoints in opposite directions makes them run as two
 * visibly separate parallel lines end-to-end. `offset` of 0 reproduces the default bezier, so
 * single-reflector edges (one per route-table, no overlap) are unaffected.
 */
export const OffsetBezierEdge: React.FC<EdgeProps> = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  style,
  label,
  labelStyle,
  labelBgStyle,
  data
}) => {
  const offset = (data?.offset as number) ?? 0;
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY: sourceY + offset,
    targetX,
    targetY: targetY + offset,
    sourcePosition,
    targetPosition
  });

  return (
    <BaseEdge
      path={edgePath}
      markerEnd={markerEnd}
      style={style}
      labelX={labelX}
      labelY={labelY}
      label={label}
      labelStyle={labelStyle}
      labelShowBg
      labelBgStyle={labelBgStyle}
      labelBgPadding={[4, 2]}
      labelBgBorderRadius={4}
    />
  );
};
